import { useState } from "react";
import { NumberInput, useInput } from "react-admin";

interface PercentageDecimalNumberInputProps {
  source: string;
  label: string;
  min?: number;
  max?: number;
  step?: string | number | undefined;
  defaultValue?: number;
  disabled?: boolean;
}

const PercentageDecimalNumberInput: React.FC<
  PercentageDecimalNumberInputProps
> = ({ source, label, min, max, step, defaultValue, disabled = false }) => {
  const { field } = useInput({ source });

  const [stateValue, setStateValue] = useState<string>(
    parseFloat((field.value * 100).toFixed(2)).toString()
  );

  const handleChange = (event: any) => {
    const { value } = event.target;
    const parsedValue = parseFloat(value);

    if (
      value.toString().startsWith("0") &&
      !value.toString().startsWith("0.")
    ) {
      event.target.value = parsedValue.toString();
    }

    if (isNaN(parsedValue)) {
      event.target.value = "0";
    }
    if (event.target.value?.split(".")?.[1]?.length > 2) {
      event.target.value = event.target.value?.toFixed(2);
    }
    setStateValue(event.target.value);
  };
  return (
    <div className="w-full relative">
      <NumberInput
        max={max !== undefined ? max : 100}
        min={min !== undefined ? min : 0}
        step={step !== undefined ? step : 5}
        defaultValue={defaultValue !== undefined ? defaultValue : 0.25}
        source={source}
        label={label}
        format={(v) => {
          return parseFloat((parseFloat(v) * 100).toFixed(2)).toString();
        }}
        parse={(v) => {
          return parseFloat((parseFloat(v) / 100).toFixed(4));
        }}
        onBlur={() =>
          setStateValue((prev: string) =>
            parseFloat(parseFloat(prev).toFixed(2)).toString()
          )
        }
        fullWidth
        onChange={handleChange}
        aria-invalid={false}
        disabled={disabled}
      />
      {!!stateValue?.length && (
        <span
          className="absolute top-[24px] pointer-events-none"
          style={{
            left: `${
              (stateValue?.length + 2 - (stateValue.includes(".") ? 1 : 0)) * 10
            }px`
          }}
        >
          %
        </span>
      )}
    </div>
  );
};

export default PercentageDecimalNumberInput;
